import * as React from 'react';
import svgStyle from '../svg_Style.less';
import { EntwicklungsplanBalken } from './EntwicklungsplanBalken';
import { relativeTimeThreshold } from 'moment';
import { IDs } from '../../../helpers/IDs';
import { fn2 } from '../../../core/formatter/formatNumber';

interface EntwicklungsplanSpalteProps extends React.ClassAttributes<any> {
    data: any;
    column_position: number;
    columns_total: number;
    shifting: number;
    height_total: number;
    width_total: number;
    spalt_idx: number;
    spalten_daten: any;
    showEkz?: boolean;
    onSelect: (id: number) => void;
}

export class EntwicklungsplanSpalte extends React.Component<EntwicklungsplanSpalteProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private gap_top = 15;
    private gap_bottom = 5;

    render() {
        const bar_height = 50; // Höhe des orangenen balkens
        const height_reduce = (this.props.columns_total - this.props.column_position) * this.props.shifting; // Fehlende Höhe wg. dem "shifting"

        const width = (this.props.width_total / this.props.columns_total);  // Breite anhand der Spaltenanzahl
        const offset_x = width * this.props.column_position;                // X-Position anhand der Spaltenanzahl

        // Höhenberechnungen
        const height_available = this.props.height_total - height_reduce;
        const height_top = (this.props.height_total * 0.6) - bar_height;
        const height_bottom = (height_available - height_top - bar_height);

        // Infos / Daten
        const daten = this.props.spalten_daten;
        const firstCol = daten.length > 0 ? daten[0] : {};
        const spalt = daten[this.props.spalt_idx];
        const name = spalt && spalt.name ? spalt.name : '';
        const ekzKuerzel = firstCol && firstCol.ekzKuerzel ? firstCol.ekzKuerzel : null;
        const kennzahlen = this.props.data[IDs.ENT_KENNZAHLEN_DEFINTION];
        const ekzFnd = kennzahlen.find((k: any) => k.kuerzel === ekzKuerzel);
        const ekzEinheit = ekzFnd ? ekzFnd.einheit : '';
        let ekz = spalt && typeof spalt.ekz === 'object' && spalt.ekz[ekzKuerzel] ? spalt.ekz[ekzKuerzel] : '';
        ekz = fn2(ekz.toString().replace(',', '.'));
        const massnahmen = spalt && spalt.massnahmen ?
        spalt.massnahmen.filter((str: string) => str && str.trim() !== '').join(' #hr# ') : '';
        const refStyle: CSSStyleDeclaration  = window.getComputedStyle(document.body);
        const colorDateneingabe: string = refStyle ? refStyle.getPropertyValue('--color-main-section-dateneingabe') : '#84b0d6';
        const colorZusatztools: string = refStyle ? refStyle.getPropertyValue('--color-main-section-zusatztools') : '#f36f23';

        return (
            <g
                onClick={() => this.props.onSelect(this.props.column_position)}
                style={{ cursor: 'pointer' }}
            >
                <EntwicklungsplanBalken
                    width={width - this.gap_top}
                    height={height_top}
                    offset_x={offset_x}
                    // offset_y={(height_bottom + bar_height) - this.props.shifting * 2}
                    offset_y={(height_bottom + bar_height) - this.props.shifting + 10}
                    height_total={this.props.height_total}
                    color='#dbe0e9'
                    plain_base={false}
                    shifting={this.props.shifting}
                    text_content={massnahmen}
                    text_bottom_offset_y={-20}
                    text_bottom_value={this.props.showEkz ? 'EKZ ' + (ekz ? ekz + ' ' + ekzEinheit : '') : ''}
                    text_bottom_color={colorZusatztools}
                    // text_bottom_color={'#f36f23'}
                    columns_total={this.props.columns_total}
                />
                <EntwicklungsplanBalken
                    width={width}
                    height={bar_height}
                    offset_x={offset_x}
                    // offset_y={height_bottom - this.props.shifting}
                    offset_y={height_bottom + 10}
                    height_total={this.props.height_total}
                    color={colorZusatztools}
                    // color='#f36f23'
                    plain_base={false}
                    shifting={this.props.shifting}
                    drawArrowhead={this.props.column_position === this.props.columns_total - 1 ? true : false}
                    columns_total={this.props.columns_total}
                />
                <EntwicklungsplanBalken
                    width={width - this.gap_bottom}
                    height={height_bottom}
                    offset_x={offset_x}
                    // offset_y={0}
                    offset_y={this.props.shifting + 10}
                    height_total={this.props.height_total}
                    color={colorDateneingabe}
                    // color='#84b0d6'
                    plain_base={true}
                    shifting={this.props.shifting}
                    text_bottom_value={name}
                    text_bottom_center={true}
                    text_bottom_color='#ffffff'
                    text_offset_x={(width - 90) / 2}
                    columns_total={this.props.columns_total}
                />
            </g>
        );
    }
}
